import { render, staticRenderFns } from "./pub_media.vue?vue&type=template&id=2991947c&scoped=true"
import script from "./pub_media.vue?vue&type=script&lang=js"
export * from "./pub_media.vue?vue&type=script&lang=js"
import style0 from "./pub_media.vue?vue&type=style&index=0&id=2991947c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991947c",
  null
  
)

export default component.exports